export const dateFormat = 'DD/MMM/YYYY'

export const ArticleDateFormat = 'MMMM DD [DE] YYYY'
